import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getWebsiteStage, getWebsiteVersion } from "../modules/stages";

/**
 * Footer - shows the server and website stages/versions
 */
export default function Footer() {
    const backendDetails = useSelector((state) => state.user.backendDetails);

    return (
        <Box
            component="footer"
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 3,
                px: 2,
                py: 0.5,
                borderTop: 1,
                borderColor: "divider",
                color: "text.secondary",
            }}
        >
            {backendDetails && (
                <Typography variant="caption">
                    Server: {backendDetails.stage.toUpperCase()} -&nbsp;
                    {backendDetails.version}
                </Typography>
            )}
            <Typography variant="caption">
                Website: {getWebsiteStage().toUpperCase()} -&nbsp;
                {getWebsiteVersion()}
            </Typography>
        </Box>
    );
}
